/* ovd-scroll-restore.js — Back returns you to where you were.
   This theme's Barba intercepts Back and re-navigates it as a brand-new
   "navigate" load, so the browser never flags history traversal and native
   restoration is dead. Detection therefore uses three signals:
   1. real traversal (popstate / back_forward)             -> restore
   2. arrival WITHOUT a fresh link-click marker            -> restore
      (covers Barba's fake-forward Back; a deliberate click always plants a
       marker first, and markers expire after 8s so a lost one can't wedge us)
   3. arrival WITH a fresh marker = a real forward click   -> top, as normal */
(function () {
  try { history.scrollRestoration = 'manual'; } catch (e) {}
  var S = window.sessionStorage;
  function key() { return 'ovdScroll:' + location.pathname + location.search; }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    if (h.startsWith('#') || a.target === '_blank') return;
    try { S.setItem(key(), String(window.scrollY)); S.setItem('ovdNav:fwd', String(Date.now())); } catch (er) {}
  }, true);
  addEventListener('pagehide', function () {
    try { S.setItem(key(), String(window.scrollY)); } catch (er) {}
  });

  function restore() {
    var y; try { y = parseFloat(S.getItem(key()) || '0'); } catch (er) { return; }
    if (!y) return;
    var tries = 0;
    (function attempt() {
      window.scrollTo(0, y);
      if (Math.abs(window.scrollY - y) > 2 && tries++ < 60) setTimeout(attempt, 100);
    })();
  }

  function arrive(viaTraversal) {
    var fresh = false;
    try {
      var ts = parseInt(S.getItem('ovdNav:fwd') || '0', 10);
      S.removeItem('ovdNav:fwd');
      fresh = ts && (Date.now() - ts) < 3000;
    } catch (er) {}
    var nav = performance.getEntriesByType('navigation')[0];
    if (viaTraversal || (nav && nav.type === 'back_forward') || !fresh) restore();
  }

  if (document.readyState === 'complete') setTimeout(function(){ arrive(false); }, 50);
  else addEventListener('load', function () { setTimeout(function(){ arrive(false); }, 50); });
  addEventListener('popstate', function () { setTimeout(function(){ arrive(true); }, 250); });
})();
